"use client"
import {
  cn
} from "./chunk-Q2O3JHTB.js";

// src/input/input.tsx
import { useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Input = ({
  label,
  labelClassName,
  error,
  name,
  type = "text",
  className,
  required,
  innerWrapperClassName,
  ref,
  outerWrapperClassName,
  ...rest
}) => {
  const isPassword = type === "password";
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const handletoggleShowPassword = () => {
    setIsPasswordShown((prev) => !prev);
  };
  const fieldType = isPasswordShown ? "text" : type;
  return /* @__PURE__ */ jsx("div", { className: cn(outerWrapperClassName), children: /* @__PURE__ */ jsxs("div", { className: "", children: [
    label && /* @__PURE__ */ jsxs(
      "label",
      {
        htmlFor: name,
        className: cn("select-label", error && "", labelClassName),
        children: [
          label,
          required && /* @__PURE__ */ jsx("span", { className: "", children: "*" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: cn(
          "input-form-wrapper w-full",
          innerWrapperClassName,
          error && "!text-heritage-red-60 !border-heritage-red-60"
        ),
        children: [
          /* @__PURE__ */ jsx(
            InputOrTextArea,
            {
              ref,
              id: name,
              name,
              type: fieldType,
              className: cn(
                "w-full focus-visible:outline-none",
                className,
                error && ""
              ),
              ...rest
            }
          ),
          isPassword && /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              disabled: rest.disabled,
              className: cn("inline-flex body-xs label", error && "", {
                "cursor-pointer": !rest.disabled
              }),
              onClick: handletoggleShowPassword,
              children: isPassword ? !isPasswordShown ? "Show" : "hide" : null
            }
          )
        ]
      }
    ),
    error && /* @__PURE__ */ jsx("p", { className: "error-message", children: error })
  ] }) });
};
var input_default = Input;
var InputOrTextArea = ({
  type,
  ref,
  ...rest
}) => {
  if (type === "textarea") {
    return /* @__PURE__ */ jsx("textarea", { ref, ...rest });
  }
  return /* @__PURE__ */ jsx("input", { ref, type, ...rest });
};

export {
  input_default
};
